<template>
	<div class="sidebar-basisgenus" ref="sidebarBasisgenus">
		<div class="row">
			<div class="list-col col-6">
				<erco-list class="list-available-genus"
				           :items="data.draggable"
				           :draggable="true"></erco-list>
			</div>
			<div class="destinations-col col-6">
			    <div v-for="(destination, index) in data.destinations"
			         class="input-wrapper"
			         :key="index"
			         @dragover="handleDragOver($event)"
			         @drop="handleDrop(index, $event)">
					<erco-text-input :keepUnfocused="true"
					                 :label="destination.label"
					                 :text="destination.text"
					                 :resetable="true"
					                 :droppable="true"
					                 @reset="handleReset(index)">
					</erco-text-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ErcoList from '@/components/atoms/ErcoList';
	import ErcoTextInput from '@/components/molecules/ErcoTextInput';

	export default {
		name: 'ErcoSidebarBasisgenusMolecule',

		props: {
			data: {
				type: Object,
				default: (function dataDefault() {
					return {
						draggable: [],
						destinations: [],
					};
				}()),
			},
		},

		data() {
			return {
				enabled: {},
			};
		},

		methods: {

			handleDragOver($event) {
				$event.dataTransfer.effectAllowed = 'copy';
				$event.preventDefault();
			},

			handleDrop(index, e) {
				const destinationData = this.data.destinations[index];
				const itemData = e.dataTransfer.getData('text/plain');

				if (!itemData) {
					return false;
				}

				const parsedItemData = JSON.parse(itemData);
				const newSidebarValue = JSON.parse(JSON.stringify(this.$store.state.sidebar.context));

				newSidebarValue.value[destinationData.key] = {
					id: parsedItemData.id,
					value: parsedItemData.value,
					type: destinationData.type,
				};

				const newSidebarOutputData = JSON.parse(JSON.stringify(this.data));
				this.$set(newSidebarOutputData.destinations[index], 'id', parsedItemData.id);
				this.$set(newSidebarOutputData.destinations[index], 'text', parsedItemData.value);

				this.$store.dispatch('updateSidebar', {
					context: newSidebarValue,
					outputData: newSidebarOutputData,
				});

				e.preventDefault();
				return false;
			},

			handleReset(index) {
				const destinationData = this.data.destinations[index];
				const newSidebarOutputData = JSON.parse(JSON.stringify(this.data));
				const newSidebarValue = JSON.parse(JSON.stringify(this.$store.state.sidebar.context));

				this.$set(newSidebarValue.value, destinationData.key, {
					id: null,
					value: null,
					type: destinationData.type,
				});

				this.$set(newSidebarOutputData.destinations[index], 'id', '0');
				this.$set(newSidebarOutputData.destinations[index], 'text', '');

				this.$store.dispatch('updateSidebar', {
					context: newSidebarValue,
					outputData: newSidebarOutputData,
				});
			},
		},

		components: {
			ErcoList,
			ErcoTextInput,
		},
	};
</script>

<style lang="scss">
	.sidebar-basisgenus {
		padding: 0.5rem;
		padding-top: 1.5rem;

		.list-available-genus > ul {
			list-style-type: none;
		}
	}
</style>



// WEBPACK FOOTER //
// Basisgenus.vue?89784a1e